enum MarketplaceRoutesEnum {
  'EXPLORER' = '/explorer',
  'LOCATIONS' = '/locations',
  'LOCATION' = '/location',
}

export default MarketplaceRoutesEnum
